import Diameter from '@/models/dackpartner/Diameter'

export function createDefaultDiameters(): Diameter[] {
  const result = []

  const diameters = [15, 16, 17, 18, 19]

  for (const diameter of diameters) {
    result.push(new Diameter({ inch: diameter, amount: 0 }))
  }

  return result
}
